/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-item-container"><div class="coupon-info-area"><div class="left-area"><div class="discount-area"><span class="discount">{{ couponInfo.price }}</span><span class="left-text">{{ couponInfo.priceUnit }}</span></div><span class="confine-text" v-if="(couponInfo.priceTip)">{{ couponInfo.priceTip }}</span></div><div class="right-area"><span class="name" v-if="(couponInfo.name)">{{ couponInfo.name }}</span><span class="expire-time-text">{{ couponInfo.expiredTimeText }}{{ couponInfo.remark }}</span></div></div><mpx-view :style="[(couponStatusInfo.text_color)] | transRpxStyle" @tap="tapCoupon" class="coupon-status-area"><span class="lockIcon" v-if="(isUnlock)"></span>{{ couponStatusInfo.text }}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2fc57e1e"}'>
  .coupon-item-container
    position relative
    border-radius 10px
    background #FFF6F1
    height 82px
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    &:last-child
      margin-bottom 0
    .coupon-info-area
      height 100%
      display flex
      align-items center
      justify-content center
      .left-area
        width 90px
        display flex
        flex-shrink 0
        flex-direction column
        align-items center
        .discount-area
          display flex
          align-items baseline
          justify-content center
          .discount, .unit
            font-weight 400
            color #F86316
          .discount
            font-family Barlow Semi Condensed
            font-size 35px
            line-height 35px
          .maxAmount
            font-family PingFang SC
            font-size 14px
            line-height 15px
          .left-text
            font-family PingFang SC
            font-size 11px
            font-weight 400
            line-height 11px
            color #FF5900
            margin-left 2px
        .confine-text
          font-family PingFang SC
          font-size 10px
          font-weight normal
          line-height 10px
          color #B69786
          margin-top 5px
      .right-area
        display flex
        flex-direction column
        .name
          font-family PingFang SC
          font-size 15px
          font-weight 600
          line-height 15px
          color #333
          margin-bottom 7px
        .expire-time-text, .discount
          font-family PingFang SC
          font-size 10px
          font-weight normal
          line-height 13px
          color #B69786
          padding-right 5px
        .expire-time-text
          margin-bottom 5px
    .coupon-status-area
      flex-shrink 0
      width 94px
      height 61px
      display flex
      align-items center
      justify-content center
      border-left 1px dashed rgba(248, 99, 22, 0.3)
      font-family PingFang SC
      font-size 15px
      font-weight 500
      line-height 15px
      color #F86316
      &-cyber
        font-size 14px
      .lockIcon
        display inline-block
        width 16px
        height 16px
        background-image url('https://dpubstatic.udache.com/static/dpubimg/5ortLTbddtPLQovuSjArt.png')
        background-size 100% 100%
        margin-right 2px
    .arrow
      position relative
      &::after
        content ''
        top 6px
        right -5px
        position absolute
        width 2px
        height 2px
        border-top 1.5px solid
        border-right 1.5px solid
        transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2fc57e1e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2fc57e1e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2fc57e1e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2fc57e1e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2fc57e1e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
